import React from 'react';
interface PaxStatementHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    uen: string;
  };
  statement: {
    number: string;
    printedOn: string;
    printedBy: string;
    bookingReference: string;
    salesOwner: string;
    bookingStatus: 'Deposit Paid' | 'Confirmed' | 'Cancelled';
  };
}
export function PaxStatementHeader({
  company,
  statement
}: PaxStatementHeaderProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Confirmed':
        return 'bg-green-50 text-green-700 border-green-200';
      case 'Deposit Paid':
        return 'bg-yellow-50 text-yellow-700 border-yellow-200';
      case 'Cancelled':
        return 'bg-red-50 text-red-700 border-red-200';
      default:
        return 'bg-neutral-50 text-neutral-700 border-neutral-200';
    }
  };
  return <>
      {/* Top Header */}
      <div className="flex justify-between items-start mb-8" data-id="element-688">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-689">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-690">
            <span className="text-white font-bold text-xl" data-id="element-691">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-692">
            {company.name}
          </h1>
          <div className="text-xs text-neutral-600 space-y-0.5 leading-relaxed" data-id="element-693">
            {company.address.map((line, i) => <p key={i} data-id="element-694">{line}</p>)}
            <p className="mt-2" data-id="element-695">Tel: {company.phone}</p>
            <p data-id="element-696">UEN: {company.uen}</p>
          </div>
        </div>

        {/* Right: Statement Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-697">
          <div className="space-y-2" data-id="element-698">
            <div className="flex justify-between" data-id="element-699">
              <span className="text-xs font-medium text-neutral-600" data-id="element-700">
                Pax Statement No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-701">
                {statement.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-702">
              <span className="text-xs font-medium text-neutral-600" data-id="element-703">
                Printed On:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-704">
                {statement.printedOn}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-705">
              <span className="text-xs font-medium text-neutral-600" data-id="element-706">
                Printed By:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-707">
                {statement.printedBy}
              </span>
            </div>
            <div className="h-px bg-neutral-200 my-2" data-id="element-708" />
            <div className="flex justify-between" data-id="element-709">
              <span className="text-xs font-medium text-neutral-600" data-id="element-710">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-711">
                {statement.bookingReference}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-712">
              <span className="text-xs font-medium text-neutral-600" data-id="element-713">
                Sales Owner:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-714">
                {statement.salesOwner}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <div className="text-center mb-4" data-id="element-715">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight mb-3" data-id="element-716">
          PAX STATEMENT
        </h2>
        <div className="flex items-center justify-center gap-4" data-id="element-717">
          <span className={`text-xs font-semibold px-3 py-1.5 rounded-full border ${getStatusColor(statement.bookingStatus)}`} data-id="element-718">
            {statement.bookingStatus}
          </span>
        </div>
      </div>
    </>;
}